import React from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect, HashRouter } from "react-router-dom";

// core components
import Admin from "layouts/Admin.js";
import Login from "views/Login";

import "assets/css/material-dashboard-react.css?v=1.9.0";
import {
  ToastsContainer,
  ToastsStore,
  ToastsContainerPosition,
} from "react-toasts";
// import { GuardProvider, GuardedRoute } from "react-router-guards";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const hist = createBrowserHistory();

const requireLogin = (to, from, next) => {
  if (to.meta.auth) {
    if (localStorage.user) {
      next();
    }
    next.redirect("/login");
  } else {
    next();
  }
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2b7b56",
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <ToastsContainer
        store={ToastsStore}
        position={ToastsContainerPosition.TOP_RIGHT}
      />
      <HashRouter>
        {/* <GuardProvider guards={[requireLogin]} loading={null} error={Login}> */}
        <Switch>
          <Route path="/admin" component={Admin} meta={{ auth: true }} />
          <Route path="/login" component={Login} />
          <Route
            exact
            path="/"
            render={() => {
              return localStorage.user ? (
                <Redirect to="/admin" />
              ) : (
                <Redirect to="/login" />
              );
            }}
          />
          <Route path="*" component={Login} />
          {/* <Redirect from="/" to="/admin/dashboard" /> */}
        </Switch>
        {/* </GuardProvider> */}
      </HashRouter>
    </MuiPickersUtilsProvider>
  </ThemeProvider>,
  document.getElementById("root")
);
